import { useState, useLayoutEffect, RefObject } from 'react';

interface DropdownPosition {
  top: number;
  left: number;
  width: number;
}

/**
 * Hook para calcular y actualizar la posición del dropdown
 */
export function useMasterDropdownPosition(
  open: boolean,
  triggerRef: RefObject<HTMLDivElement>
) {
  const [dropdownPos, setDropdownPos] = useState<DropdownPosition>({
    top: 0,
    left: 0,
    width: 320,
  });

  useLayoutEffect(() => {
    if (open && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setDropdownPos({
        top: rect.bottom + 18,
        left: rect.left + -150,
        width: dropdownPos.width,
      });
    }
  }, [open, triggerRef]);

  return dropdownPos;
}
